import { RefreshCw } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useHealthPassCard } from "../../hooks/useHealthPassCard";
import { useI18nStore } from "../../stores/i18nStore";
import { CardActionButtons } from "./CardActionButtons";
import { CardFlip } from "./CardFlip";
import { HealthPassCardBack } from "./HealthPassCardBack";
import { HealthPassCardFront } from "./HealthPassCardFront";

/**
 * The card on Home: front side up, a tap turns it over to the wallet, and the
 * four card actions underneath (UX_CONCEPT.md §5.1–5.2).
 */
export const HealthPassCardWidget: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18nStore();
  const { cardData, qrData, walletItems, isQrLoading, isLoading } =
    useHealthPassCard();
  const [flipped, setFlipped] = useState(false);

  const flipLabel = flipped ? t.homeShowFront : t.homeShowWallet;

  return (
    <section aria-labelledby="home-card">
      <div className="flex items-center justify-between">
        <h2
          id="home-card"
          className="font-display text-[19px] font-bold text-ink"
        >
          {t.homeYourCard}
        </h2>
        <button
          type="button"
          onClick={() => setFlipped((f) => !f)}
          className="flex min-h-[44px] items-center gap-1.5 text-sm font-semibold text-primary-700"
        >
          <RefreshCw className="h-4 w-4" aria-hidden="true" />
          {flipLabel}
        </button>
      </div>

      <div className="mt-2 flex flex-col items-center">
        {isLoading ? (
          <div className="w-full max-w-[342px] aspect-[85.6/54] rounded-[18px] bg-primary-100 animate-pulse" />
        ) : (
          <div className="w-full max-w-[342px]">
            <CardFlip
              isFlipped={flipped}
              onFlip={() => setFlipped((f) => !f)}
              flipLabel={flipLabel}
              front={
                <HealthPassCardFront
                  cardData={cardData}
                  qrData={qrData}
                  isQrLoading={isQrLoading}
                />
              }
              back={
                <HealthPassCardBack
                  cardData={cardData}
                  walletItems={walletItems}
                />
              }
            />
          </div>
        )}
        <p className="mt-3 text-center text-xs text-muted-foreground">
          {flipped ? t.homeCardHintBack : t.homeCardHintFront}
        </p>
      </div>

      <div className="mx-auto mt-4 w-full max-w-[420px]">
        <CardActionButtons
          layout="horizontal"
          onWalletClick={() => navigate("/traveler/card/wallet")}
        />
      </div>
    </section>
  );
};
